export default "__VITE_ASSET__B2SGD6EK__"